<template>
<div>
    <v-tabs
      v-model="active"
      :touchless="true"
      color="transparent"
      slider-color="red lighten-3"
    >
      <v-tab
        v-for="n in tabs"
        :key="n"
        ripple
      >
        {{n}}

      </v-tab>
      <v-tabs-items v-model="active" touchless>
      <v-tab-item>        
        <admin-shops @refreshShops="(e) => this.$emit('shopsMenu')" @siteAlert="(e) => this.$emit('siteAlert',e)" @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess',e)" @siteAlertInfo="(e) => this.$emit('siteAlertInfo',e)" ></admin-shops>
      </v-tab-item>
      <v-tab-item>
        <admin-owners @refreshShops="(e) => this.$emit('shopsMenu')"  @siteAlert="(e) => this.$emit('siteAlert',e)" @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess',e)" @siteAlertInfo="(e) => this.$emit('siteAlertInfo',e)" ></admin-owners>
      </v-tab-item>
      <v-tab-item>
           <admin-app  @siteAlert="(e) => this.$emit('siteAlert',e)" @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess',e)" @siteAlertInfo="(e) => this.$emit('siteAlertInfo',e)" ></admin-app>
      </v-tab-item>
      <v-tab-item>
        <admin-dlc  @siteAlert="(e) => this.$emit('siteAlert',e)" @siteAlertSuccess="(e) => this.$emit('siteAlertSuccess',e)" @siteAlertInfo="(e) => this.$emit('siteAlertInfo',e)" ></admin-dlc>
      </v-tab-item>
      </v-tabs-items>
    </v-tabs>
</div>
</template>

<script>
import AdminShops from './pieces/AdminShops'
import AdminOwners from './pieces/AdminOwners'
import AdminApp from './pieces/AdminApp'
import AdminDlc from './pieces/AdminDlc'
// import ajax from '../../ajax'
export default {
  name: 'Manager',
  components: { AdminShops, AdminOwners, AdminApp, AdminDlc },
  mounted: function() {
    
    this.init()
  },
  data: () => {
    return {
      h: null,
      active: null,
      tabs: []
    }
  },
  methods: {
    init: function() {
      this.tabs = [
        this.getString('Negozi'),
        this.getString('Clienti'),
        this.getString('App'),
        this.getString('Dlc')
      ]
    },
    getString: function (key, values) {
            return this.$store.state.currentTranslator.getString(key, values)
    }
  }
}
</script>

<style>
.q-dark-bk {
  background-color: #424242 !important;
}

.q-dark-text {
  color: #f5f5f5 !important;
}

.q-light-bk {
  color: #f5f5f5 !important;
}

.q-light-text {
  color: #424242 !important;
}

.full-width {
  width: 100% !important;
}

h1,
h2,
h3 {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Manager.vue